import * as React from "react";

import "./LoginPage.css";

import { connect } from "react-redux";
import { logIn } from "../thunks/loginThunks";
import { RootState } from "../types";

interface IProps {
  isLoading: boolean;
  error: Error | null;
  onLogin: (email: string, password: string) => void;
}

interface IState {
  email: string;
  password: string;
}

export class LoginPage extends React.Component<IProps, IState> {
  public state = {
    email: "",
    password: "",
  };

  public render() {
    const { error, isLoading } = this.props;
    const { email, password } = this.state;

    return (
      <form className="login-page" onSubmit={this.onSubmit}>
        <input
          placeholder="email"
          value={email}
          onChange={this.onEmailChange}
          type="text"
        />
        <br />
        <input
          placeholder="password"
          value={password}
          onChange={this.onPasswordChange}
          type="password"
        />
        <br />
        <input type="submit" disabled={isLoading} value="Log In" />
        <div>{error ? error.message : null}</div>
      </form>
    );
  }

  private onSubmit = (e: React.FormEvent) => {
    const { email, password } = this.state;
    const { onLogin } = this.props;

    e.preventDefault();

    return onLogin(email, password);
  };

  private onEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ email: e.target.value });
  };

  private onPasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ password: e.target.value });
  };
}

export const LoginContainer = connect(
  ({ login }: RootState) => ({
    error: login.error,
    isLoading: login.isLoading,
  }),
  dispatch => ({
    onLogin: (email: string, password: string) => {
      // HACK: <any> shouldnt be here
      dispatch<any>(logIn(email, password));
    },
  })
)(LoginPage);

export default LoginContainer;



// WEBPACK FOOTER //
// ./src/pages/LoginPage.tsx